import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/question-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8C119 8 8 119.1 8 256 8 393 119 504 256 504S504 393 504 256C504 119.1 393 8 256 8zM256 456C145.5 456 56 366.6 56 256 56 145.5 145.5 56 256 56 366.5 56 456 145.5 456 256 456 366.5 366.6 456 256 456zM363.2 200.8C363.2 267.9 290.8 268.9 290.8 293.7V300C290.8 306.6 285.5 312 278.8 312H233.2C226.5 312 221.2 306.6 221.2 300V291.3C221.2 255.6 248.3 241.3 268.8 229.8 286.3 220 297.1 213.3 297.1 200.2 297.1 183 275.1 171.6 257.3 171.6 234.1 171.6 223.4 182.5 208.4 201.5 204.3 206.6 196.9 207.6 191.7 203.6L163.9 182.5C158.8 178.7 157.6 171.5 161.2 166.2 184.8 131.5 214.9 112 261.8 112 310.9 112 363.2 150.3 363.2 200.8zM298 368C298 391.2 279.2 410 256 410S214 391.2 214 368 232.8 326 256 326 298 344.8 298 368z'
      }
    ]
  }
})
